import styled from "styled-components"

const AttachmentImage = styled.img`
  margin-top: ${({ theme }) => theme.space[2]}px;
  width: 100%;
  object-fit: cover;
`

export default AttachmentImage
